import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt"; // Changed arrow icon
import ModeEditOutlineSharpIcon from "@mui/icons-material/ModeEditOutlineSharp";
import PaletteIcon from "@mui/icons-material/Palette";
import DescriptionIcon from "@mui/icons-material/Description";

const Menu = ({ toggleDrawer, editItem }) => {
  const menuItems = [
    { id: "action", title: "Action", icon: <ModeEditOutlineSharpIcon /> },
    { id: "design", title: "Design", icon: <PaletteIcon /> },
    // { id: "popupDesign", title: "Popup Design", icon: <PaletteIcon /> },
    { id: "content", title: "Contents", icon: <DescriptionIcon /> },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "600px",
        // border: "1px solid #ccc",
        backgroundColor: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
        // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "10px",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
          {`Header Item ${editItem.index + 1}`}
        </Typography>
      </Box>

      {/* Menu List */}
      <List>
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            <ListItem
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 10px", // Reduced padding for smaller height
              }}
            >
              <ListItemIcon sx={{ minWidth: "40px" }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.title} />
              <IconButton
                onClick={() => {
                  toggleDrawer(editItem.open, editItem.index, item.id);
                }}
              >
                <ArrowRightAltIcon /> {/* Changed the icon */}
              </IconButton>
            </ListItem>
            {index <= menuItems.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default Menu;
